import React from 'react';
// import logo from './SS.png';
import './App.css';
import { UserForm } from './components/UserForm'

function App() {
  return (
    <div className="App">
      <UserForm />
    </div>
  );
}

export default App;
